
const dateFormat = require('bmh/date-format');
import { Component, Vue } from 'vue-property-decorator';
import zhCN from 'ant-design-vue/es/date-picker/locale/zh_CN';
const getUrl = require('baimahu/url-with-param');
const qs = require('qs');
const { VUE_APP_FCAPI: FCAPI } = process.env;
import { namespace } from 'vuex-class';
import UploadFile from '@/component/upload-file.vue';
import XLSX from 'xlsx';
import { getTimestampByExcelTimeValue } from '../chuang/lib/upload-file';

const _ = {
  uniqBy: require('lodash/uniqBy'),
  xorBy: require('lodash/xorBy')
};

enum enumMergeDialog {
  choose_company,
  confirm_data
}
function enteyValidateMapFormat() {
  return {
    full_name: {
      value: '',
      status: '',
      help: ''
    },
    is_tob: {
      value: 1,
      status: '',
      help: ''
    },
    present_head_id: {
      value: [],
      status: '',
      help: ''
    }
  };
}

function validateCompanyMapFormat() {
  return {
    contact_type: {
      value: '',
      status: '',
      help: ''
    },
    wechat: {
      value: '',
      status: '',
      help: ''
    },
    phone: {
      value: '',
      status: '',
      help: ''
    },
    branch_id: {
      value: '',
      status: '',
      help: ''
    },
    username: {
      value: '',
      status: '',
      help: ''
    },
    // present_head_id: {
    //   value: '',
    //   status: '',
    //   help: '',
    // },
    charge_teacher_id: {
      value: '',
      status: '',
      help: ''
    },
    user_teacher_id: {
      value: [],
      status: '',
      help: ''
    },
    is_keyman: {
      value: 1,
      status: '',
      help: ''
    }
  };
}
function validateStudentMapFormat() {
  return {
    branch_id: undefined,
    username: undefined,
    phone: undefined,
    charge_teacher_id: undefined,
    user_teacher_id: undefined
  };
}

const API = {
  get_follower_list: `${FCAPI}/boss/hundun/company/follower`,
  get_list: `${FCAPI}/boss/hundun/company`,
  post_merge: `${FCAPI}/boss/hundun/company/merge`,
  post_follower: `${FCAPI}/boss/hundun/company/followerrele`,
  put_follower: `${FCAPI}/boss/hundun/company/followerrele/`,
  delete_follower: `${FCAPI}/boss/hundun/company/followerrele/0`,
  post_status: `${FCAPI}/boss/hundun/company/status`,
  add_log: `${FCAPI}/boss/hundun/company/log`,
  user_list: `${FCAPI}/boss/hundun/user`,
  add_data: `${FCAPI}/boss/hundun/company/tob/`,
  create_task: `${FCAPI}/boss/hundun/user/task`,
  post_company: `${FCAPI}/boss/hundun/company`,
  serch_detailInfo: `${FCAPI}/boss/hundun/user/search/0`,
  export_student: `${FCAPI}/boss/hundun/company/user`,
  get_relevance: `${FCAPI}/boss/hundun/company/relevance`
};

const employees_table: any = {
  '0': {
    employees_number_floor: 0,
    employees_number_ceil: 50
  },
  '1': {
    employees_number_floor: 51,
    employees_number_ceil: 100
  },
  '2': {
    employees_number_floor: 101,
    employees_number_ceil: 500
  },
  '3': {
    employees_number_floor: 501,
    employees_number_ceil: 100000
  }
};

function initForm() {
  return {
    is_all: 0, //默认分页，传1表示不分页
    current: 1,
    is_export: 0, //是否导出
    limit: 20,
    full_or_part_name: '',
    location: '',
    industry: '',
    employees_number_floor: '',
    employees_number_ceil: '',
    cooperation_state: -2,
    income_range_begin: '',
    income_range_end: '',
    college: '',
    is_tob: '',
    remark: '',
    user_mobile: '',
    is_exist_order: '',
    order_count: '',
    begin_start_time: [],
    finish_start_time: [],
    present_follower_id: [],
    follow_up_content: ''
  };
}
function validateMapFormat() {
  return {
    full_name: {
      value: '',
      status: ''
    },
    is_tob: {
      value: 1,
      status: '',
      help: ''
    },
    standard: {
      value: '',
      status: '',
      help: ''
    }
  };
}

const Hundun = namespace('Hundun');
@Component({
  components: { UploadFile }
})
export default class CompanyList extends Vue {
  @Hundun.State('teacher_list') teacher_list: any; //负责班主任

  validate_student_map: any = validateStudentMapFormat();
  entry_validate_map: any = enteyValidateMapFormat();
  validate_company_map: any = validateCompanyMapFormat();
  export_input_is_disabled = true;
  get teacher_widthout_all() {
    let s = [...this.teacher_list];
    s.pop();
    return s.slice(1);
  }
  entry_visible_time = 1;
  entry_visible = false;
  company_id = 0;
  form_merge_company: any;
  more_change_form: any;
  form = initForm();
  merge_from: any = initForm();
  employees_id: any = '';
  is_loading = false;
  locale = zhCN;
  table_data: any = {};
  table_data_merge: any = {};
  select_row_key = [];
  select_row_data = []; //已选择的具体数据
  merge_select_row_data: any = []; //已选择的具体数据
  // select_row_key: any = [];
  current = 0;
  more_change = [
    {
      id: 1,
      value: '跟进状态'
    },
    {
      id: 2,
      value: '目前跟进人'
    }
  ];
  show_add_tag = false; // 添加标签弹框
  more_id = -1; //批量修改类型选择www
  merge_dialog = false;
  enumMergeDialog = enumMergeDialog;
  merge_dialog_type = enumMergeDialog.choose_company;
  follower_list: any = [];
  cooperation_type_map = [
    { name: '请选择', id: -2 },
    { name: '暂无明确需求，持续跟进', id: 1 },
    { name: '待匹配合作方案', id: 2 },
    { name: '已出合作方案待回复', id: 4 },
    { name: '待签约', id: 5 },
    { name: '已合作', id: 3 },
  ];
  merge_indeterminate = false;
  merge_checked = false;
  show_students_dialog = false;
  user_table: any = {};
  select_students_name = '';
  choose_students_data: any = {};
  focus_follower: any = [];
  select_row_data_user_number: any = 0;
  validate_map: any = validateMapFormat();
  window = window as any;
  upload_visible = false;
  upload_file = [];
  header = {
    A1: { v: '企业全称' },
    B1: { v: '企业简称' },
    C1: { v: '企业规模' },
    D1: { v: '年营收（单位：万）' },
    E1: { v: '公司简介' },
    F1: { v: '关键人' },
    G1: { v: '关键人电话' },
    H1: { v: '职位' },
    I1: { v: '跟进状态' },
    J1: { v: '负责班主任' },
    K1: { v: '目前跟进人' },
    L1: { v: '回访时间' },
    M1: { v: '备注' }
  };
  connect_company_visible = false;
  relevance_list: any = [];

  async handleAddTubi() {
    if (!this.select_row_key.length) {
      this.$message.error('请先勾选要添加兔必的企业');
      return;
    }
    // let arr = Array.from(this.select_row_key);
    // console.log(typeof arr);
    // console.log(arr);
    // console.log(typeof this.select_row_key);
    // console.log(this.select_row_key);
    const send_data = {
      id_list: this.select_row_key
    };

    const res: any = await this.$axios.post(`${API.add_data}`, send_data);
    if (res.data.status === 200) {
      this.init();
      this.$message.success('添加成功');
      this.select_row_key = [];
      this.select_row_data_user_number = 0;
      return;
    }
  }
  // 批量修改弹框
  changeMore() {
    if (this.select_row_data.length === 0) {
      this.$message.error('请先勾选要批量修改的企业');
      return;
    }
    this.more_change_form.resetFields(),
      // this.button_type = 3;
      (this.more_id = -1);
    this.show_add_tag = true;
  }

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d');
  }
  //翻页
  changePageMerge(page: any) {
    this.initMerge(page.current);
  }

  //翻页
  changeUserPage(page: any) {
    this.initUser(page.current);
  }

  //翻页
  changePage(page: any) {
    this.current = page.current;
    this.init(page.current);
  }

  handleChooseAllMerge() {
    if (this.select_row_key.length === this.table_data_merge.detail.length) {
      this.merge_checked = false;
      this.merge_indeterminate = false;
      this.select_row_key = [];
      this.merge_select_row_data = [];
    } else {
      this.select_row_key = this.table_data_merge.detail.map((item: any) => item.id);
      this.merge_select_row_data = this.table_data_merge.detail;
      this.merge_checked = true;
      this.merge_indeterminate = false;
    }
    console.log(this.select_row_key);
  }

  async search(page = 1) {
    this.form_merge_company.resetFields(['full_name', 'standard']);
    if (this.employees_id) {
      this.form.employees_number_floor = employees_table[this.employees_id].employees_number_floor;
      this.form.employees_number_ceil = employees_table[this.employees_id].employees_number_ceil;
    } else {
      this.form.employees_number_floor = '';
      this.form.employees_number_ceil = '';
    }
    this.init(page);
    console.log(this.form);
  }
  entryData() {
    this.entry_visible = true;
  }
  async checkUserInfo(values: any) {
    const send_data = {
      connect_type: this.validate_company_map.contact_type.value,
      connect_value: values.target.value
    };
    const res: any = await this.$axios.get(`${API.serch_detailInfo}?${qs.stringify(send_data)}`);
    if (res.data.data) {
      this.validate_company_map.branch_id.value = res.data.data.branch_id;
      this.validate_company_map.username.value = res.data.data.name;
      this.validate_company_map.charge_teacher_id.value = res.data.data.charge_teacher_id ? res.data.data.charge_teacher_id : '';
      this.validate_company_map.user_teacher_id.value = res.data.data.user_teacher.map((item: any) => item.teacher_id);
      this.export_input_is_disabled = true;
    } else {
      this.export_input_is_disabled = false;
    }
  }
  focusUserInfo() {
    this.export_input_is_disabled = true;
  }
  async entrySubmit(type: any) {
    this.export_input_is_disabled = true;
    const reg = /^1[3|4|5|7|8|9][0-9]{9}$/;
    let is_valid = true;
    if (type == 1) {
      if (!this.entry_validate_map.full_name.value) {
        this.entry_validate_map.full_name.status = 'error';
        this.entry_validate_map.full_name.help = '请输入企业名称';
        is_valid = false;
      }
      if (this.entry_validate_map.present_head_id.value.length == 0) {
        this.entry_validate_map.present_head_id.status = 'error';
        this.entry_validate_map.present_head_id.help = '请选择跟进人';
        is_valid = false;
      }
      if (!is_valid) return;
      const send_data = {
        full_name: this.entry_validate_map.full_name.value,
        is_tob: this.entry_validate_map.is_tob.value,
        present_head_id: this.entry_validate_map.present_head_id.value
      };
      const res_post: any = await this.$axios.post(API.post_company, send_data);
      if (res_post.data.status === 200) {
        this.company_id = res_post.data.data.id;
        this.entry_visible_time = 2;
      } else {
        this.validate_map.full_name.status = 'error';
        this.validate_map.full_name.help = '企业已存在';
      }
      console.log(this.entry_visible_time);

      return;
    } else {
      if (!this.validate_company_map.branch_id.value) {
        this.validate_company_map.branch_id.status = 'error';
        this.validate_company_map.branch_id.help = '请选择分社';
        is_valid = false;
      }
      if (!this.validate_company_map.username.value) {
        this.validate_company_map.username.status = 'error';
        this.validate_company_map.username.help = '请填写姓名';
        is_valid = false;
      }
      if (!this.validate_company_map.contact_type.value) {
        this.validate_company_map.contact_type.status = 'error';
        this.validate_company_map.contact_type.help = '请选择联系方式';
        is_valid = false;
      }
      if (!this.validate_company_map.wechat.value && this.validate_company_map.contact_type.value === 2) {
        this.validate_company_map.wechat.status = 'error';
        this.validate_company_map.wechat.help = '请填写微信';
        is_valid = false;
      }
      if (!reg.test(this.validate_company_map.phone.value) && this.validate_company_map.contact_type.value === 1) {
        this.validate_company_map.phone.status = 'error';
        this.validate_company_map.phone.help = '请输入正确的手机号';
        is_valid = false;
      }
      if (!is_valid) return;
      const send_data: any = {
        name: this.validate_company_map.username.value,
        mobile: this.validate_company_map.phone.value,
        branch_id: this.validate_company_map.branch_id.value,
        connect_type: this.validate_company_map.contact_type.value ? this.validate_company_map.contact_type.value : undefined,
        wechat: [this.validate_company_map.wechat.value],
        charge_teacher_id: this.validate_company_map.charge_teacher_id.value,
        teacher_id: this.validate_company_map.user_teacher_id.value,
        company_id: this.company_id,
        is_keyman: this.validate_company_map.is_keyman.value,
        input_type: 2
      };
      send_data.charge_teacher_id = send_data.charge_teacher_id.length === 0 ? 0 : send_data.charge_teacher_id;

      console.log(send_data);
      const res: any = await this.$axios.post(API.user_list, send_data);
      if (res.data.status === 200) {
        this.$message.success('录入成功');
        this.entry_visible = false;
        this.search(this.table_data.current);
      } else {
        this.$message.error(res.data.message);
      }
    }
  }

  async exportData(page = 1) {
    this.form_merge_company.resetFields(['full_name', 'standard']);
    if (this.employees_id) {
      this.form.employees_number_floor = employees_table[this.employees_id].employees_number_floor;
      this.form.employees_number_ceil = employees_table[this.employees_id].employees_number_ceil;
    } else {
      this.form.employees_number_floor = '';
      this.form.employees_number_ceil = '';
    }
    const begin_start_time = this.form.begin_start_time[0] ? Math.floor((this.form.begin_start_time[0] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
    const finish_start_time = this.form.begin_start_time[1] ? Math.floor((this.form.begin_start_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
    const begin_end_time = this.form.finish_start_time[0] ? Math.floor((this.form.finish_start_time[0] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
    const finish_end_time = this.form.finish_start_time[1] ? Math.floor((this.form.finish_start_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
    const income_range_begin = this.form.income_range_begin ? Math.floor(this.form.income_range_begin as any) * 10000 : 0;
    const income_range_end = this.form.income_range_end ? Math.floor(this.form.income_range_end as any) * 10000 : 99999999999;

    const url = `${API.get_list}?${qs.stringify({
      ...this.form,
      present_follower_id: this.form.present_follower_id.toString(),
      begin_start_time,
      finish_start_time,
      begin_end_time,
      finish_end_time,
      income_range_begin,
      income_range_end,
      current: this.table_data.current,
      is_export: 1,
      is_all: 1,
      limit: undefined
    })}`;
    const res: any = await this.$axios.get(url);
    if (res.data.status === 200) {
      window.location.href = url;
    }
  }

  onSelectChange(select_row_key: any, value: any) {
    let number: any = 0;
    value.forEach((element: any) => {
      number = number + element.user_number;
    });
    this.select_row_data_user_number = number;

    this.select_row_data = value;
    this.select_row_key = select_row_key;
    const select_data = [...this.merge_select_row_data, ...value];
    this.merge_select_row_data = _.uniqBy(select_data, (e: any) => {
      return e.id;
    });
    console.log(this.merge_select_row_data);
  }

  //分页
  paginationOption(remote: any) {
    return {
      current: +remote.current || 0,
      total: remote.total || 0,
      pageSize: remote.limit || 0,
      showTotal: () => `共${remote.total}条，每页${remote.limit}条`
    };
  }

  handleClear() {
    this.form = initForm();
    this.employees_id = undefined;
    // this.init(1);
  }

  handleClearMerge() {
    this.merge_from = initForm();
    // this.initMerge(1);
  }

  changeMoretype(id: number) {
    this.more_id = id;
    console.log(this.more_id);
  }

  async init(page = 1) {
    const begin_start_time = this.form.begin_start_time[0] ? Math.floor((this.form.begin_start_time[0] as any).hours(23).minutes(59).seconds(59) / 1000) : '';
    const finish_start_time = this.form.begin_start_time[1] ? Math.floor((this.form.begin_start_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 86400 : '';
    const begin_end_time = this.form.finish_start_time[0] ? Math.floor((this.form.finish_start_time[0] as any).hours(23).minutes(59).seconds(59) / 1000) : '';
    const finish_end_time = this.form.finish_start_time[1] ? Math.floor((this.form.finish_start_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 86400 : '';
    const income_range_begin = this.form.income_range_begin ? Math.floor(this.form.income_range_begin as any) * 10000 : 0;
    const income_range_end = this.form.income_range_end ? Math.floor(this.form.income_range_end as any) * 10000 : 99999999999;

    const res: any = await this.$axios.get(
      `${API.get_list}?${qs.stringify({
        ...this.form,
        current: page,
        present_follower_id: this.form.present_follower_id.toString(),
        begin_start_time,
        finish_start_time,
        begin_end_time,
        finish_end_time,
        income_range_begin,
        income_range_end
      })}`
    );
    if (res.data.data) {
      res.data.data.detail.forEach((element: any) => {
        element.follower_separate = element.follower_separate.map((item: any) => item.follower_id);
      });
    }
    this.table_data = res.data.data ? res.data.data : [];
    console.log(this.table_data.detail);
    this.select_row_key = [];
  }

  async initMerge(page = 1) {
    const url = getUrl(API.get_list, {
      ...this.merge_from,
      current: page,
      full_or_part_name: this.merge_from.full_name,
      full_name: undefined,
      limit: 10
    });
    const res: any = await this.$axios.get(url);
    this.table_data_merge = res.data.data ? res.data.data : [];
  }

  cancel() {
    this.show_add_tag = false;
  }

  submit() {
    this.more_change_form.validateFields(async (err: any, values: any) => {
      if (!err) {
        for (let item in values) {
          if (values[item] === undefined) {
            values[item] = null;
          }
        }
        console.log(values);
        this.axiosCooperation(this.select_row_key, values['status']);
        const post_list: any = [];
        this.select_row_key.forEach((e: any) => {
          post_list.push(
            this.$axios.put(`${API.put_follower}${e}`, {
              follower_id_list: values['follow']
            })
          );
        });
        await Promise.all(post_list);
        this.merge_select_row_data = [];
        this.select_row_key = [];
        // if (this.more_id === 0) {
        //   this.axiosCooperation(this.select_row_key, values.status);
        // } else {
        //   const post_list: any = [];
        //   this.select_row_key.forEach((e: any) => {
        //     post_list.push(
        //       this.$axios.put(`${API.put_follower}${e}`, {
        //         follower_id_list: values.second
        //       })
        //     );
        //   });
        //   await Promise.all(post_list);
        //   this.merge_select_row_data = [];
        //   this.select_row_key = [];
        // }
        this.show_add_tag = false;
        this.init(this.current);
        this.select_row_key = [];
        this.select_row_data = [];
        this.select_row_data_user_number = 0;
      }
    });
    console.log(this.more_change_form.validateFields());
    console.log(this.form_merge_company);
  }
  // submit() {
  //   this.more_change_form.validateFields(async (err: any, values: any) => {
  //     if (!err) {
  //       console.log(values);
  //       if (this.more_id === 0) {
  //         this.axiosCooperation(this.select_row_key, values.second);
  //       } else {
  //         const post_list: any = [];
  //         this.select_row_key.forEach((e: any) => {
  //           post_list.push(
  //             this.$axios.put(`${API.put_follower}${e}`, {
  //               follower_id_list: values.second
  //             })
  //           );
  //         });
  //         await Promise.all(post_list);
  //         this.merge_select_row_data = [];
  //         this.select_row_key = [];
  //       }
  //       this.show_add_tag = false;
  //       this.init();
  //       this.select_row_key = [];
  //       this.select_row_data = [];
  //     }
  //   });
  //   console.log(this.more_change_form.validateFields());
  //   console.log(this.form_merge_company);
  // }

  mergeNext() {
    try {
      console.log(this.merge_select_row_data);

      if (this.select_row_key.length > 1) {
        const merge_send_data: any = [];
        this.select_row_key.forEach((element: any) => {
          merge_send_data.push(this.merge_select_row_data.filter((item: any) => item.id === element)[0]);
          // merge_send_data.push(element);
        });
        console.log(this.merge_select_row_data);

        console.log(this.table_data_merge.detail);

        this.merge_select_row_data = merge_send_data;
        this.merge_dialog_type = enumMergeDialog.confirm_data;
      } else {
        this.$message.error('请选择最少两个企业');
      }
    } catch (error) {
      console.log(error);
    }

    console.log(this.select_row_key);
  }

  mergeSubmit() {
    let is_valid = true;
    // if (!this.validate_map.full_name.value) {
    //   this.validate_map.full_name.status = 'error';
    //   this.validate_map.full_name.help = '请输入合并后的全称';
    //   is_valid = false;
    // }
    console.log(this.validate_map.standard);

    if (!this.validate_map.full_name.value) {
      this.merge_select_row_data.forEach((element: any) => {
        if (this.validate_map.standard.value == element.id) {
          console.log(element.full_name);

          this.validate_map.full_name.value = element.full_name;
        }
      });
    }
    if (!this.validate_map.standard.value) {
      this.validate_map.standard.status = 'error';
      this.validate_map.standard.help = '请选择合并标准';
      is_valid = false;
    }
    if (!is_valid) {
      return;
    }
    // const send_data = {
    //   master_id: this.validate_map.standard,
    //   slave_id_list: this.select_row_key,
    //   full_name: this.validate_map.full_name
    // };
    // const res: any = this.$axios.post(API.post_merge, send_data);
    // if (res.data.status !== 200) {
    //   this.$message.error('没有操作权限');
    //   this.merge_dialog = false;
    //   this.init(this.table_data.current);
    // }
    this.form_merge_company.validateFields(async (err: any, values: any) => {
      if (!err) {
        const send_data = {
          master_id: this.validate_map.standard.value,
          slave_id_list: this.select_row_key.filter((item: any) => item !== this.validate_map.standard.value),
          full_name: this.validate_map.full_name.value
        };
        const res: any = await this.$axios.post(API.post_merge, send_data);
        this.merge_dialog = false;
        this.init(this.table_data.current);
      }
    });
  }
  mergeCancel() {
    this.merge_dialog = false;
  }

  handleShowMergeDialog() {
    // this.merge_select_row_data = [];
    // this.select_row_key = [];
    this.validate_map = validateMapFormat();
    this.merge_dialog_type = enumMergeDialog.choose_company;
    this.handleClearMerge();
    this.merge_dialog = true;
    this.merge_checked = false;
    this.merge_indeterminate = false;
    this.initMerge(1);
  }

  // mergeOnSelect(record, selected, selectedRows, nativeEvent) {
  //   console.log(record);
  //   console.log(selected);
  //   console.log(selectedRows);
  //   console.log(nativeEvent);
  // }
  mergeOnSelectChange(select_row_key: any, value: any) {
    this.select_row_key = select_row_key;
    console.log(select_row_key);

    console.log(value);

    // this.merge_select_row_data =
    const select_data = [...this.merge_select_row_data, ...value];
    this.merge_select_row_data = _.uniqBy(select_data, (e: any) => {
      return e.id;
    });
    if (this.select_row_key.length === this.table_data_merge.detail.length) {
      this.merge_indeterminate = false;
      this.merge_checked = true;
      return;
    }
    if (this.select_row_key.length) {
      this.merge_indeterminate = true;
    } else {
      this.merge_indeterminate = false;
      this.merge_checked = false;
    }
  }

  beforeCreate() {
    this.form_merge_company = this.$form.createForm(this);
    this.more_change_form = this.$form.createForm(this);
  }

  handleView(record: any) {
    console.log(record);
    this.$router.push({
      path: '/hundun/company-detail',
      query: { id: record.id, name: record.full_name }
    });
  }

  async initFollower() {
    const send_data = {
      current: 1,
      limit: 999999,
      weixin_nickname: '',
      mobile: '',
      charge: '',
      status: 0
    };
    const url = getUrl(API.get_follower_list, send_data);
    const res: any = await this.$axios.get(url);
    this.follower_list = res.data.data
      ? [
        ...res.data.data.detail,
        {
          weixin_nickname: '无',
          id: 0
        }
      ]
      : [
        {
          weixin_nickname: '无',
          id: 0
        }
      ];
  }

  async handleEditFollower(value: any, record: any, is_delete: any = false) {
    const follower_name: any = this.follower_list.filter((item: any) => {
      return item.id === value;
    })[0];
    console.log(follower_name.weixin_nickname);
    const res: any = is_delete
      ? await this.$axios.delete(`${API.delete_follower}?company_id=${record.id}&follower_id=${value}`)
      : await this.$axios.post(API.post_follower, {
        company_id: record.id,
        follower_id: value,
        follower_name: follower_name.weixin_nickname
      });
    if (res.data.status === 200) {
      this.$message.success('修改成功');
    }
  }

  async addLog(log: any, item: any) {
    if (!log) {
      this.$message.error('请输入备注');
      return;
    }
    const send_data = {
      company_id: item.id,
      content: `备注  “${log}”`
    };
    const res: any = await this.$axios.post(API.add_log, send_data);
    if (res.status == 200) {
      this.$message.success('提交成功');
      item.explain = '';
    }
  }
  async exportStudent(record: any) {
    console.log(record);
    const send_data = { is_export: 1, company_id: record.id };
    const url = `${API.export_student}?${qs.stringify(send_data)}`;
    try {
      const res: any = await this.$axios.get(url);
      if (res.status === 200) window.location.href = url;
    } catch (error) {
      console.log(error);
    }
  }

  async axiosCooperation(list: any, id: number) {
    const res: any = await this.$axios.post(API.post_status, {
      id_list: list,
      cooperation_state: id
    });
    if (res.data.status === 200) {
      this.$message.success('修改成功');
    }
  }

  async initUser(page = 1) {
    const send_data = {
      current: page,
      limit: 10,
      company_id: this.choose_students_data.id,
      corp_name: this.choose_students_data.full_name,
      sort: 'keyman'
    };
    const url = getUrl(API.user_list, send_data);
    const res: any = await this.$axios.get(url);
    this.user_table = res.data.data ? res.data.data : [];
  }

  handleShowStudents(item: any) {
    this.select_students_name = `${item.full_name}/`;
    console.log(item);
    this.user_table = {};
    this.choose_students_data = item;
    this.show_students_dialog = true;
    this.initUser(1);
  }

  filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  // 导入
  creatData() {
    this.upload_visible = true;
  }
  readExcel(sheet_data: any) {
    const ref: any = sheet_data['!ref'];
    const right_string: string = ref.split(':')[1];
    const max_number = right_string.replace(/[^0-9]/gi, '');
    const arr: any = [];
    for (let index = 2; index <= Number(max_number); index++) {
      const cooperation_state = sheet_data['I' + index] ? this.cooperation_type_map.find((item: any) => item.name == sheet_data['I' + index].v)?.id : 0;
      const charge_teacher_id = sheet_data['J' + index] ? this.teacher_list.find((item: any) => item.weixin_nickname == sheet_data['J' + index].v)?.id : 0;
      const present_follower = [] as any[];
      const present_follower_list = sheet_data['K' + index] ? sheet_data['K' + index].v.toString().split(',') : [];
      present_follower_list.forEach((element: any) => {
        present_follower.push({
          follower_id: this.follower_list.find((item: any) => item.weixin_nickname == element)?.id,
          follower_name: element
        });
      });
      console.log(charge_teacher_id);

      // this.follower_list
      const obj = JSON.parse(
        JSON.stringify({
          full_name: sheet_data['A' + index] ? sheet_data['A' + index].v : '',
          part_name: sheet_data['B' + index] ? sheet_data['B' + index].v : '',
          employees_number: sheet_data['C' + index] ? sheet_data['C' + index].v : 0,
          income: sheet_data['D' + index] ? sheet_data['D' + index].v * 10000 : 0,
          wiki: sheet_data['E' + index] ? sheet_data['E' + index].v : '',
          keyman: sheet_data['F' + index] ? sheet_data['F' + index].v : '',
          keyman_mobile: sheet_data['G' + index] ? sheet_data['G' + index].v : '',
          corp_position: sheet_data['H' + index] ? sheet_data['H' + index].v : '',
          cooperation_state: cooperation_state,
          charge_teacher_id: charge_teacher_id,
          present_follower: present_follower,
          callback_time: sheet_data['L' + index] ? getTimestampByExcelTimeValue(sheet_data['L' + index].v) : 0,
          log: sheet_data['M' + index] ? sheet_data['M' + index].v : ''
        })
      );
      arr.push(obj);
    }
    this.upload_file = arr;
  }
  async uploadOk() {
    const res = await this.$axios.post(`${FCAPI}/boss/hundun/company/import`, { list: this.upload_file });
    if (res.data.status !== 200) return this.$message.error('导入失败');
    this.$message.success('导入成功!');
    this.search();
    this.upload_visible = false;
  }
  uploadCancel() {
    this.upload_visible = false;
  }
  downloadTemplate() {
    const output = Object.assign({}, this.header);
    const ref = 'A1:M1';
    const wb = {
      SheetNames: ['企业总表模板'],
      Sheets: {
        企业总表模板: Object.assign({}, output, { '!ref': ref })
      }
    };
    XLSX.writeFile(wb, '企业总表模板.xlsx');
  }

  // 关联企业
  async associatedCompany(row: any) {
    this.connect_company_visible = true;
    const send_data = {
      company_id: row.id,
      current: 1,
      limit: 9999
    };
    const url = getUrl(API.get_relevance, send_data);
    const res: any = await this.$axios.get(url);
    let arr = [];
    if (res.data.status === 200) {
      arr = res.data?.data?.detail ? res.data.data.detail : {};
    }
    this.relevance_list = arr.map((item: any) => item.company);
  }
  // 查找跟进人
  searchFollower(list: number[]) {
    let str = '';
    if (list) {
      list.forEach((item: any) => {
        const name = this.follower_list.find((val: any) => val.id == item)?.weixin_nickname;
        if (name) str = str + ', ' + name;
      });
    }
    return str.slice(1);
  }

  created() {
    this.init();
    this.initFollower();
  }
}
